export enum QueryKey {
  BusinessPartnersList = 'business-partners-list',
  BusinessPartnersListWithoutContextPartner = 'business-partners-list-without-context-partner',
  BusinessPartner = 'business-partner',
  BusinessPartnerPlans = 'business-partner-plans',
  SelectDeviceModalDevicesList = 'select-device-modal-devices-list',
  DeviceToken = 'device-token',
  DevicesList = 'devices-list',
  Doctors = 'doctors',
  FamilyUsers = 'family-users',
  Patients = 'patients',
  BusinessPartnerMedicalOperatorsList = 'business-partner-medical-operators-list',
  BusinessPartnerMedicalOperator = 'business-partner-medical-operator',
  BusinessPartnerMedicalOperatorPatientsList = 'business-partner-medical-operator-patients-list',
  BusinessPartnerDevicesList = 'business-partner-devices-list',
  BusinessPartnerAdditionalDevicesList = 'business-partner-additional-devices-list',
  SuperAdminAdditionalDevicesList = 'super-admin-additional-devices-list',
  SelectAdditionalDevicesToAssignList = 'select-additional-devices-to-assign-list',
  BusinessPartnerAdminsList = 'business-partner-admins-list',
  BusinessPartnerDoctorsList = 'business-partner-doctors-list',
  BusinessPartnerDoctor = 'business-partner-doctor',
  BusinessPartnerPatient = 'business-partner-patient',
  BusinessPartnerProfileOwnersList = 'business-partner-profile-owners-list',
  BusinessPartnerPatientsList = 'business-partner-patient-list',
  SelectUnassignedBusinessPartnerDevicesList = 'select-unassigned-business-partner-devices-list',
  UserSettings = 'user-settings',
  DictionaryList = 'dictionary-list',
}
